import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthActions } from '@tsin-core/store/auth/auth.actions';
import { AuthState } from '@tsin-core/store/auth/auth.state';
import { throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {

  const store: Store = inject(Store);
  const token = store.selectSnapshot<string | null>(AuthState.getToken);
  const refreshToken = store.selectSnapshot<string | null>(AuthState.getRefreshToken);

  const skipAuthEndpoints = ['/api/auth/refresh', '/generate-otp', '/enable-email-2fa'];
  const shouldSkipAuth = skipAuthEndpoints.some(p => req.url.includes(p));

  if (token && token.length > 0) {
    if (!shouldSkipAuth) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  }

  return next(req).pipe(
    catchError((error: any) => {
      if (error.status === 401 &&
        error.error &&
        error.error.name === 'TokenExpiredError' &&
        refreshToken &&
        !req.url.includes('/api/auth/refresh')) {

        // Return the observable from the dispatch operation
        return store.dispatch(new AuthActions.RefreshToken({ refreshToken })).pipe(
          catchError(() => throwError(() => error)), // If refresh fails, propagate original error
          switchMap((response: any) => {
            console.log('new token', response);
            const newToken = response.token;
            if (newToken) {
              const clonedReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`
                }
              });
              return next(clonedReq);
            }
            return throwError(() => error);
          })
        );
      }

      // For other errors, just propagate
      return throwError(() => error);
    })
  );
};
